import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LandingLayout from './components/LandingLayout';
import Section from './components/Section';
import PricingCards from './components/PricingCards';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function PricingPage() {
  return (
    <LandingLayout>
      <Section background="#F8FAFD" py={{ xs: 8, md: 12 }}>
        <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 8 } }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2rem', md: '3rem' },
              fontWeight: 800,
              color: '#163567',
              mb: 2,
            }}
          >
            Simple, School-Friendly Pricing
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '1.05rem', md: '1.2rem' },
              color: '#555',
              lineHeight: 1.7,
              maxWidth: 550,
              mx: 'auto',
            }}
          >
            Start with one classroom or go school-wide. No per-seat fees. No surprises.
          </Typography>
        </Box>
        <PricingCards />
      </Section>

      {/* FAQ */}
      <Section background="#FFFFFF">
        <Box sx={{ maxWidth: 700, mx: 'auto' }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.5rem', md: '2rem' },
              fontWeight: 800,
              color: '#163567',
              textAlign: 'center',
              mb: { xs: 4, md: 6 },
            }}
          >
            Frequently Asked Questions
          </Typography>
          {[
            {
              q: 'Can I try Pressto before purchasing?',
              a: 'Yes! Every plan comes with a 7-day free trial — full access, no credit card required. That\'s enough time to import your students, publish your first newspaper, and see the magic. Contact us for a guided demo with your team.',
            },
            {
              q: 'Is there a per-student fee?',
              a: 'No. All plans include unlimited students. Whether you have 20 students or 200, the price stays the same.',
            },
            {
              q: 'What about student data privacy?',
              a: 'Pressto is FERPA and COPPA compliant. Student PII is never sent to AI systems. All AI operates on anonymized content only.',
            },
            {
              q: 'Does it work with our existing curriculum?',
              a: 'Yes. Pressto works with Nearpod, BrainPOP, Amplify, CKLA, EL Education, and any other curriculum. Enter a topic, paste a lesson, or upload an assignment.',
            },
            {
              q: 'What grades does Pressto support?',
              a: 'Pressto supports grades 2-12 with age-appropriate scaffolds, templates, and AI feedback that adapts to student level.',
            },
          ].map((faq) => (
            <Box
              key={faq.q}
              sx={{
                mb: 3,
                pb: 3,
                borderBottom: '1px solid #E8EDF5',
                '&:last-child': { borderBottom: 'none' },
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#163567', mb: 1 }}>
                {faq.q}
              </Typography>
              <Typography sx={{ fontSize: '0.9rem', color: '#555', lineHeight: 1.7 }}>
                {faq.a}
              </Typography>
            </Box>
          ))}
        </Box>
      </Section>

      <TestimonialsSection />
      <CTASection />
    </LandingLayout>
  );
}
